import { type FC, Fragment } from "react";

import StepIndicator from "./StepIndicator";
import type { NavigationListType } from "./type";

interface FormNavigationProps {
  navigationList: NavigationListType;
}

const FormNavigation: FC<FormNavigationProps> = ({ navigationList }) => {
  return (
    <div className="flex justify-between items-center mb-8 gap-2 px-4 md:px-8">
      {navigationList.map((step, index) => (
        <Fragment key={step.id}>
          <StepIndicator
            step={step}
            isLast={index === navigationList.length - 1}
          />
        </Fragment>
      ))}
    </div>
  );
};

export default FormNavigation;
